import project1 from "./Img/project1.png" 
import project2 from "./Img/project2.png" 
import project3 from "./Img/project3.png" 
import project4 from "./Img/project4.png" 
import project5 from "./Img/project5.png" 
import project6 from "./Img/project6.png" 
import project7 from "./Img/project7.png" 
import project8 from "./Img/project8.png" 
import project9 from "./Img/project9.png" 
import project10 from "./Img/project10.png" 
import project11 from "./Img/project11.png" 
import project12 from "./Img/project12.png" 
import project13 from "./Img/project13.png" 
import project14 from "./Img/project14.png"
import project15 from "./Img/project15.png" 
import project16 from "./Img/project16.png"  






export const datas = [
    {
      id: "1",
      title: "Web Designer",
      time:" (2021 - 2022)",
      discription:"I am a good web designer. I took a designing online course and learned from it. "
    },
    {
      id: "2",
      title: "Front-End Developer",
      time:" (2021 - 2022)",
      discription:"I am front-end web developer but i don't have any experience for working other as i didn't get any internship or a project for work but i hav created some project for developing my skills and for my practice. "
    },
    {
      id: "3",
      title: "Web Developer",
      time:" (2021 - 2022)",
      discription:"I am going to complete full stack web developer soon from online web developer course. "
    },
    {
      id: "4",
      title: "Back-End Developer",
      time:" (2022 - 2023)",
      discription:" I am currently working on backend skills and i will complete my backend skills soon. After that i will become full stack web developer, but i didn't get any inetrnship but i will created some project for sharpen my skills."
    }
  ];



  export const projectDetail = [
    {
      id: 0,
      projectNumber:"01",
      title:"Showroom Website",
      detail:"This project is created with the help of HTML and CSS.",
      github:"https://github.com/chetanya1423/showroom.github.io/commits/main",
      live:"https://chetanya1423.github.io/showroom.github.io/",
      background:`${project1}`
    },
      {
        id:1,
        projectNumber:"02",
        title:"Food Restaurant",
        detail:"This project is created with the help of HTML and CSS.",
        github:"https://github.com/chetanya1423/resfoodtemp.github.io",
        live:"https://chetanya1423.github.io/resfoodtemp.github.io/",
        background:`${project2}`
      },
      {
        id:2,
        projectNumber:"03",
        title:"Colour Game",
        detail:"This project is created with the help of HTML, CSS and javascript.",
        github:"https://github.com/chetanya1423/ColourGameRes.github.io",
        live:"https://chetanya1423.github.io/ColourGameRes.github.io/",
        background:`${project3}`
      },
      {
        id:3,
        projectNumber:"04",
        title:"Drumkit",
        detail:"This project is created with the help of HTML, CSS and javascript.",
        github:"https://github.com/chetanya1423/drumkit.github.io",
        live:"https://chetanya1423.github.io/drumkit.github.io/",
        background:`${project4}`
      },
      {
        id:4,
        projectNumber:"05",
        title:"Spotify Clone",
        detail:"This project is created with the help of HTML, CSS and javascript.",
        github:"https://github.com/chetanya1423/Spotifyclone.github.io",
        live:"https://chetanya1423.github.io/Spotifyclone.github.io//",
        background:`${project5}`
      },
      {
        id:5,
        projectNumber:"06",
        title:"Car Animation",
        detail:"This project is created with the help of HTML, CSS .",
        github:"https://github.com/chetanya1423/CarAnimation.github.io",
        live:" https://chetanya1423.github.io/CarAnimation.github.io/",
        background:`${project6}`
      },
      {
        id:6,
        projectNumber:"07",
        title:"Weather App",
        detail:"This project is created with the help of HTML, CSS and javascript.",
        github:"https://github.com/chetanya1423/WeatherAPP.github.io",
        live:"https://chetanya1423.github.io/WeatherAPP.github.io/",
        background:`${project7}`
      },
      {
        id:7,
        projectNumber:"08",
        title:"Music Website",
        detail:"This project is created with the help of HTML, CSS and javascript.",
        github:"https://github.com/chetanya1423/MusicWebsite.github.io",
        live:"https://chetanya1423.github.io/MusicWebsite.github.io/",
        background:`${project8}`
      },
      {
        id:8,
        projectNumber:"09",
        title:"Video to Audio Convertor",
        detail:"This project is created with the help of HTML, CSS and javascript.",
        github:"https://github.com/chetanya1423/VideoToAudio.github.io",
        live:"https://chetanya1423.github.io/VideoToAudio.github.io/",
        background:`${project9}`
      },
      {
        id:9,
        projectNumber:"10",
        title:"Discord Clone",
        detail:"This project is created with the help of HTML, Tailwind CSS.",
        github:"https://github.com/chetanya1423/discordClone",
        live:"https://discordclone-project1423.netlify.app/",
        background:`${project10}`
      },
      {
        id:10,
        projectNumber:"11",
        title:"Razor Pay Clone",
        detail:"This project is created with the help of HTML, Tailwind CSS.",
        github:"https://github.com/chetanya1423/RazorPay-clone",
        live:"https://razorpay-clone1423.netlify.app/",
        background:`${project11}`
      },
      {
        id:11,
        projectNumber:"12",
        title:"Rock Paper Scissor",
        detail:"This project is created with the help of HTML, CSS and javascript.",
        github:"https://github.com/chetanya1423/RockPaperScissor.github.io",
        live:"https://chetanya1423.github.io/RockPaperScissor.github.io/",
        background:`${project12}`
      },
      {
        id:12,
        projectNumber:"13",
        title:"Tour and Travelling",
        detail:"This project is created with the help of HTML, CSS and React js.",
        github:"https://github.com/chetanya1423/TourWithChetanya",
        live:"https://tourwithchetanya.netlify.app/",
        background:`${project13}`
      },
      {
        id:13,
        projectNumber:"14",
        title:"Top Courses",
        detail:"This project is created with the help of HTML, CSS and React js.",
        github:"https://github.com/chetanya1423/Top-Courses.github.io",
        live:"https://top-courses-by-chetanya.netlify.app/",
        background:`${project14}`
      },
      {
        id:14,
        projectNumber:"15",
        title:"Random GIF",
        detail:"This project is created with the help of HTML, CSS and React js.",
        github:"https://github.com/chetanya1423/Random-GIF.github.io",
        live:"https://random-gif-only.netlify.app/",
        background:`${project15}`
      },
      {
        id:15,
        projectNumber:"16",
        title:"Online Product",
        detail:"This project is created with the help of HTML, CSS and React js.",
        github:"https://github.com/chetanya1423/online-products",
        live:"https://online-products-clone.netlify.app/",
        background:`${project16}`
      },
    
    
  ]

